import {Box,TextArea,Button, CheckBox} from "grommet";
import {TextField} from "@mui/material/";
import {QUERY_GET_USERS,QUERY_GET_PACKAGES} from "./sendNotificationGQL.js";
import React from "react";
import { useLazyQuery } from '@apollo/client';
import Autocomplete from '@mui/material/Autocomplete';

const SendNotification = () =>{

    const [formData,setFormData]=React.useState();
    const [usersList,setUsersList] = React.useState([]);
    const [packagesList,setPackagesList] = React.useState([]);
    const [selectedUsersList,setSelectedUsersList] = React.useState([]);
    const [selectedPackagesList,setSelectedPackagesList] = React.useState([]);
    const [allUsers, setAllUsers] = React.useState(false);
    const [allPackages, setAllPackages] = React.useState(false);
    const [title, setTitle] = React.useState("");
    const [ queryGetUsers]  = useLazyQuery(QUERY_GET_USERS, {
    fetchPolicy: "no-cache",
        onCompleted: (data) => {
            console.log("DATA",data);
            let userListComposed = [];
            let dictionary ={};
            if(data["clubmate_usersregister_userregister"] != null){
                data["clubmate_usersregister_userregister"].forEach(element => {
                    dictionary["label"] = element.surname + " " + element.name + " " + element.fiscal_code;
                    dictionary["id"] = element.id;
                    userListComposed.push(dictionary);
                    dictionary = {};
                });
                console.log("userListComposed",userListComposed);
                setUsersList(userListComposed);
            }
        },
        onError:(error)=>{
        console.log(error);
        },
        notifyOnNetworkStatusChange: true, // did the work
    });

    const [ queryGetPackages]  = useLazyQuery(QUERY_GET_PACKAGES, {
    fetchPolicy: "no-cache",
        onCompleted: (data) => {
            console.log("DATA",data);
            if(data["clubmate_clubmatepackage_clubmatepackage"] != null){
                setPackagesList(data["clubmate_clubmatepackage_clubmatepackage"]);
            }
        },
        onError:(error)=>{
        console.log(error);
        },
        notifyOnNetworkStatusChange: true, // did the work
    });
    

    React.useEffect(() =>{
        queryGetUsers();
        queryGetPackages();
    },[])

    const handleAllUsers = (event) => {
        setAllUsers(event.target.checked);
        if (event.target.checked) {
            //TODO
        }
    };

    const handleAllPackages = (event) => {
        setAllPackages(event.target.checked);
        if (event.target.checked) {
            //TODO
        }
    };

    function handleChangeUsers(option){
        setSelectedUsersList(option);
    }

    function handleChangePackages(option){
        setSelectedPackagesList(option);
    }

    function handleChangeText(value){
        console.log("Text",value);
        setFormData({...formData,textMessage:value});
    }

    function handleChangeTitle(value){
        setTitle(value);
    }

    function onSendNotification(){
        let formDataApp={...formData};

        const notificationTitle = title.trim() || "Avviso";
        formDataApp={...formDataApp,"titolo":notificationTitle};

        if(allUsers){
            formDataApp={...formDataApp,"usersList":JSON.stringify(usersList.map((user)=>user?.id))};
        }else{
            formDataApp={...formDataApp,"usersList":JSON.stringify(selectedUsersList.map((user)=>user?.id))};
        }

        if(allPackages){
            formDataApp={...formDataApp,"packageList":JSON.stringify(packagesList.map((user)=>user?.id))};
        }else{
            formDataApp={...formDataApp,"packageList":JSON.stringify(selectedPackagesList.map((user)=>user?.id))};
        }

        console.log("JSON",JSON.stringify(formDataApp));

        const accessToken = sessionStorage.getItem("accessToken");
        const url = window.location.hostname;

        if (!accessToken) {
            console.error("Token di accesso non trovato in sessionStorage.");
            return;
        }

        //const apiUrl ='https://clubmate.helpmate.it/api/clubmate/send-notification' // "http://viridia.timemate.it/api/superset/login" //`https://${domain}.timemate.it/api/superset/login` //"http://viridia.timemate.it/api/superset/login" //`https://${domain}.timemate.it/api/superset/login` // window.location.origin+"/api/superset/login";

        const apiUrl = process.env.REACT_APP_BACKEND_HOST+'/api/clubmate/send-notification';

        // Opzioni per la richiesta HTTP
        const requestOptions = {
            method: "POST",
            headers: {
            "Authorization": `Bearer ${accessToken}`,
            "Content-Type": "application/json",
            },
            body: JSON.stringify(formDataApp),
        };
        // Effettua la richiesta HTTP
        fetch(apiUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Errore nella richiesta HTTP.");
                    alert("Notifica non inviata");
                }
                alert("Notifica inviata correttamente");
            })
            .catch((error) => {
                console.error("Errore durante la richiesta:", error);
                alert("Notifica non inviata");
            });
    }

    return(
        <Box direction={"column"} alignSelf={"center"} margin={"medium"} overflow-y={"scroll"} width={"800px"} height={"750px"}>
            <center>
            <h3><b>INVIA UNA NOTIFICA</b></h3>
            </center>
            <Box direction={"column"} alignSelf={"center"} gap={"small"} marginTop={"10px"}>
                <TextField
                    label="Titolo"
                    placeholder="Avviso"
                    value={title}
                    onChange={(event) => handleChangeTitle(event.target.value)}
                    style={{width:"500px", marginBottom:"10px"}}
                />
                <TextArea placeholder="Messaggio da notificare" style={{width:"500px", height:"250px"}} onChange={event => handleChangeText(event.target.value)}></TextArea>
                <Box direction={"row"} alignSelf={"center"} alignContent="start" gap={"small"} >
                <CheckBox
                    checked={allUsers}
                    label="Tutti i clienti"
                    onChange={handleAllUsers}
                    className="checkbox entrate"
                />
                <CheckBox
                    checked={allPackages}
                    label="Tutti i pacchetti"
                    onChange={handleAllPackages}
                    className="checkbox durataGiorni"
                />
                </Box>
                <center>
                {!allUsers &&(<Autocomplete
                    multiple
                    disablePortal
                    id="id-clienti"
                    options={usersList}
                    value={selectedUsersList}
                    getOptionLabel={(option) => option?.label}
                    getOptionKey={(option) => option?.id}
                    sx={{ width: 500, marginBottom: "10px" }}
                    renderInput={(params) => <TextField {...params} label="Cliente a cui notificare" />}
                    onChange={(event, value) => handleChangeUsers(value)}
                />)}
                {!allPackages &&(<Autocomplete
                    multiple
                    disablePortal
                    id="id-pacchetti"
                    options={packagesList}
                    value={selectedPackagesList}
                    getOptionLabel={(option) => option?.name}
                    getOptionKey={(option) => option?.id}
                    sx={{ width: 500  }}
                    renderInput={(params) => <TextField {...params} label="Pacchetti a cui notificare" />}
                    onChange={(event, value) => handleChangePackages(value)}
                />)}

                <Button label="INVIA" primary={true} style={{marginTop: "40px"}} onClick={() => onSendNotification()}/>
                </center>
            </Box>
        </Box>
    )
}

export default SendNotification;